export const contactsData = {
    email: 'mehedihasan120@gmail.com',
    phone: '(880) 9696-494254',
    phoneB: '(880) 9638-404254',
    phoneWp: '(880) 1763-494254',
    phoneN: '+8809696494254',
    phoneNB: '+8809638404254',
    address: 'Naogaon, Rajshahi, Bangladesh - 6500 ',
    // map: 'https://goo.gl/maps/mJMFnGTZ6aEF5pRFA',
    map: 'https://maps.app.goo.gl/xJm5LKwD1k5wBqy38',
    // map: 'https://www.google.pl/maps/dir//ICT+Tower,+Dhaka/@23.7788032,90.3394479,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3755c0b3340c1c91:0xfec009b60808d80a!2m2!1d90.3744676!2d23.7787286?hl=en',
    // map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3621.451551776136!2d88.93761117406622!3d24.814226947108473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fc7cad2088b6ad%3A0x41f2217ea991f22b!2z4Kao4KaT4KaX4Ka-4KaB!5e0!3m2!1sbn!2sbd!4v1782145948634!5m2!1sbn!2sbd',
    whatsapp: 'https://wa.me/8801763494254',
    sheetAPI: '',
}